import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';
import {FieldsModule} from '../../fields/fields.module';

import {CommonComponentsModule} from '../../../common-components.module';
import {AngularMaterialImportModule} from '../../angular-material-import-module/angular-material-import.module';
import {AddInstructionsModalComponent} from './add-instructions-modal.component';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        FieldsModule,
        UtilsModule
    ],
    declarations: [
        AddInstructionsModalComponent
    ],
    exports: [
        AddInstructionsModalComponent
    ],
    providers: [],
})
export class AddInstructionsModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/add-instructions-modal/add-instructions-modal.module.ts